import { createTheme } from '@mui/material/styles';
import { colors } from '../styles/colors.js';
import shippoTheme from '../styles/shippoTheme.js';

const radioThemeInput = {
    components: {
        MuiRadio: {
            styleOverrides: {
                root: {
                    width: shippoTheme.spacing(5),
                    height: shippoTheme.spacing(5),
                    color: colors.text.default,
                    '&.Mui-disabled': {
                        color: colors.secondaryDisabled,
                    },
                    '& .MuiTouchRipple-root': {
                        zIndex: -1,
                    },
                    '& .MuiTouchRipple-root .MuiTouchRipple-rippleVisible': {
                        color: colors.hoverFocus,
                        opacity: 1,
                    },
                    ':hover': {
                        backgroundColor: colors.selectedBackground,
                    },
                    ':focus': {
                        backgroundColor: colors.hoverFocus,
                    },
                    // unchecked Radio icon
                    '& svg[data-testId="CircleTwoToneIcon"]': {
                        '& circle': {
                            color: colors.backgroundEmphasized,
                            opacity: 1,
                        },
                    },
                },
            },
        },
    },
};
var radioTheme = createTheme(shippoTheme, radioThemeInput);

export { radioTheme as default, radioThemeInput };
//# sourceMappingURL=Radio.theme.js.map
